<template>
  <v-container class="pt-0 d-inline-flex flex-wrap" fluid>
    <div class="col-12">

      <v-card>
        <v-card-text class="pb-0 pt-2">
          <v-row class="ma-0">
            <select-project
              v-model="project"
              :project-list-custom="projectList"
              :default-value="false"
              class="col-1"
              style="min-width: 250px; max-width: 250px"
            />
            <date-picker
              v-model="from"
              label="Date"
              style="max-width: 140px"
            />

            <v-autocomplete
              style="z-index: 9999"
              :disabled="loading.deposit_by_paymethod"
              label="Country"
              placeholder="All"
              v-model="levelCountry"
              item-value="code"
              item-text="code"
              :items="countries"
              :filter="filterCountry"
              class="mx-4"
              required
              auto-select-first
              multiple
            >
              <template v-slot:prepend-item>
                <v-list-item
                  ripple
                  @click="toggleAllCountries"
                >
                  <v-list-item-action>
                    <v-icon :color="levelCountry.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>Select All</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              <template v-slot:item="{ item, attrs }">
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-checkbox-blank-outline theme--light mr-1" v-if="!attrs.inputValue"></i>
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-checkbox-marked theme--light mr-1" v-if="attrs.inputValue"></i>

                {{ item.title }} ({{ item.code }})
              </template>
            </v-autocomplete>
            <v-select
              v-model="paymethod"
              :items="paymethods"
              clearable
              label="Paymethod"
              class="mx-4"
              hide-details
            />
            <v-btn color="info" v-on:click="search()" class="mt-3" :disabled="loading.deposit_by_paymethod" :loading="loading.deposit_by_paymethod">Search</v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </div>
    <div :key="'hour-line-' + index" v-for="(chart, index) in hourCharts" :class="chart.class || 'col-lg-6 col-sm-12'">
      <default-chart :index="index" :alias="chart.alias" :title="chart.title" :data="chart.data" :series="hourSeries" :options="chart.options" :description="chart.description || ''" />
    </div>
    <div class="col-lg-12 col-sm-12">
      <h2 class="h2 text-center">Monthly Comparison</h2>
      <v-data-table
        :headers="monthCompareHeaders"
        :items="monthlySeriesCurrentYear"
        :loading="loading.statistic"
        title=""
        :items-per-page="12"
        item-key="account_id"
        hide-default-footer
        class="col-12 pa-0"
        fixed-header
      >
        <template v-slot:item.month="{ item }">
          {{ new Date(item.month.split('-')).toLocaleString('en', { month: 'long' }) }}({{ item.month }})
        </template>
        <template v-slot:item.current_registration="{ item }">
          <monthly-table-row :data="monthDifferentRow(item, 'current_registration')" />
        </template>
        <template v-slot:item.current_withdraw="{ item }">
          <monthly-table-row :data="monthDifferentRow(item, 'current_withdraw')" />
        </template>
        <template v-slot:item.current_deposit="{ item }">
          <monthly-table-row :data="monthDifferentRow(item, 'current_deposit')" />
        </template>
        <template v-slot:item.current_ngr="{ item }">
          <monthly-table-row :data="monthDifferentRow(item, 'current_ngr')" />
        </template>
        <template v-slot:item.current_ggr="{ item }">
          <monthly-table-row :data="monthDifferentRow(item, 'current_ggr')" />
        </template>
        <template v-slot:item.current_funded="{ item }">
          <monthly-table-row :data="monthDifferentRow(item, 'current_funded')" />
        </template>
      </v-data-table>
    </div>

  </v-container>
</template>

<script>
  import { map, sortBy, toArray } from 'lodash'
  import moment from 'moment/moment'
  import { API } from '@/utils/api'
  import { generateColor } from '@/utils/helper'
  import MonthlyTableRow from '@/components/bi/MonthlyTableRow.vue'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    name: 'FinanceReports',
    components: {
      SelectProject,
      DatePicker,
      MonthlyTableRow,
      DefaultChart: () => import('@/components/dashboard/DefaultChart'),
      // BarChart: () => import('@/components/dashboard/BarChart'),
      // DonutChart: () => import('@/components/dashboard/DonutChart'),
    },
    data () {
      return {
        dateRangeList,
        from: null,
        to: null,
        loading: {
          statistic: false,
          deposit_by_paymethod: false,
        },
        project: '',
        accountType: [ 'casino', 'sport' ],

        donutToggle: {},
        levelCountry: [],

        monthlySeries: [],
        hourSeries: [],
        seriesByCountry: [],
        paymethod: '',
        paymethods: [],
        dailyCharts: [
          {
            alias: 'deposit_hour',
            title: 'Deposits by Hour',
            class: 'col-lg-12 col-sm-12',
            description: '',
            data: {
              colors: [ '#00897B', '#1DE9B6' ],
              labels: [ 'Sum', 'Counts' ],
              ykeys: [ 'amount', 'account_count' ],
              xkey: 'hour',
              series: [],
              seriesKey: 'hourSeries'
            },
            options: {}
          },
        ],
        hourCharts: [
          {
            alias: 'deposit_count',
            title: 'Deposit Count by Hour (Paymethod/Country)',
            class: 'col-lg-12 col-sm-12',
            description: '',
            data: {
              colors: [ '#FF6384', '#36A2EB' ],
              labels: [ 'Deposit Count', 'Accounts Count' ],
              ykeys: [ 'deposit_count', 'account_count' ],
              xkey: 'hour',
              series: []
            },
            options: {}
          },
          {
            alias: 'deposit_sum',
            title: 'Deposit Sum by Hour (Paymethod/Country)',
            class: 'col-lg-12 col-sm-12',
            description: '',
            data: {
              colors: [ '#FF6384', '#36A2EB' ],
              labels: [ 'Deposit Sum' ],
              ykeys: [ 'amount' ],
              xkey: 'hour',
              series: []
            },
            options: {}
          },
        ],
        monthCompareHeaders: [
          { text: 'Month', align: 'left', sortable: true, value: 'month' },
          { text: 'Registration', value: 'current_registration' },
          { text: 'Deposit', value: 'current_deposit' },
          { text: 'Withdraw', value: 'current_withdraw' },
          { text: 'FTD', value: 'current_funded' },
          { text: 'GGR', value: 'current_ggr' },
          { text: 'NGR', value: 'current_ngr' },
        ],
      }
    },
    mounted () {
      this.loadPaymethods()

      this.from = moment().format('YYYY-MM-DD')
      this.to = moment().format('YYYY-MM-DD')

      this.project = this.projectList[0].value
      this.loadEntities().then((r) => {
        this.project = this.projectList[0].value
      }).then(() => this.search())
    },
    computed: {
      selectedAllCountries () {
        return this.levelCountry.length === this.countries.length
      },
      selectedSomeCountries () {
        return this.levelCountry.length > 0 && !this.selectedAllCountries
      },
      icon () {
        if (this.selectedAllCountries) return 'mdi-close-box'
        if (this.selectedSomeCountries) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
      countries: function () {
        return this.$store.state.app.countries
      },
      projectList: function () {
        return [ { text: 'All', value: null }, ...(map(this.entities || this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id, licence: i.licence }))) ]
      },
      monthDifferentRow () {
        return (currentMonth, field) => {
          const previousMonth = this.monthlySeriesCurrentYear.find((data) => {
            return this.getPreviousMonth(currentMonth.month) === data.month
          })
          if (!previousMonth) {
            return {
              value: currentMonth[field]
            }
          }
          return {
            isIncrease: currentMonth[field] > previousMonth[field],
            percentDifferent: (((currentMonth?.[field] - previousMonth?.[field]) / Math.abs(previousMonth?.[field] || 1)) * 100).toFixed(2),
            value: currentMonth[field]
          }
        }
      },
      monthlySeriesCurrentYear () {
        return this.monthlySeries.slice(Math.max(this.monthlySeries.length - 12, 0)).reverse()
      }
    },
    methods: {
      loadPaymethods () {
        return API.call('/$v/paymethod/name_list.json', { with_sub: true }, null, this.$store.state.auth.entities[0]).then(resp => {
          this.paymethods = sortBy(map(resp.data, 'name'), (o) => o)
        })
      },
      toggleAllCountries () {
        this.$nextTick(() => {
          if (this.selectedAllCountries) {
            this.levelCountry = []
          } else {
            this.levelCountry = map(this.countries.slice(), 'code')
          }
        })
      },
      filterCountry (item, queryText) {
        return (item.title.toLowerCase().includes(queryText.toLowerCase()) || item.code.toLowerCase().includes(queryText.toLowerCase()))
      },
      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.from
      },
      loadEntities () {
        return API.call('/users/entity_list.json').then(resp => {
          this.entities = resp.data
          return resp.data
        }).catch(e => {
        })
      },
      getPreviousMonth (currentMonth) {
        const currentDate = new Date(currentMonth + '-01')
        currentDate.setMonth(currentDate.getMonth() - 1)

        return currentDate.toISOString().slice(0, 7)
      },
      generateColors (length) {
        const defaultColors = [ '#FF6384', '#36A2EB', '#00897B', '#1DE9B6' ]

        return Array.from({ ...defaultColors, length }, (o) => o || generateColor())
      },

      search () {
        this.loading.statistic = true
        this.monthlySeries = []

        API.call('/reports/statistic.json', {
          from: this.from,
          to: this.to,
          by_month: true,
          months: 12,
          by_entity: this.project,
          countries: this.levelCountry,
          account_type: this.accountType
        }, null, this.$store.state.auth.entities[0]).then(resp => {
          this.monthlySeries = resp.data
          if (!resp.data || resp.data.length == 0) {
            return
          }
        }).finally(() => {
          this.loading.statistic = false
        })
        this.searchByHour()
      },
      searchByHour () {

        this.loading.deposit_by_paymethod = true

        this.hourSeries = []

        Promise.all([
          API.call('/$v/reports/deposit_by_paymethod.json', {
            from: this.from,
            to: this.from,
            preference: 'by_hour',
            by_entity: this.project,
            countries: this.levelCountry,
            paymethod: this.paymethod,
            account_type: this.accountType
          }, null, this.$store.state.auth.entities[0]).then(resp => {
            return { data: resp.data, label: 'Day' }
          }),
          API.call('/$v/reports/deposit_by_paymethod.json', {
            from: moment(this.from).subtract(30, 'days').format('YYYY-MM-DD'),
            to: this.from,
            preference: 'by_hour',
            by_entity: this.project,
            countries: this.levelCountry,
            paymethod: this.paymethod,
            avg: true,
            account_type: this.accountType
          }, null, this.$store.state.auth.entities[0]).then(resp => {
            return { data: resp.data, label: '30 Days' }
          })
        ]).then(r => {
          let out = {}

          let y = {
            'deposit_count': { items: new Set(), labels: new Set() },
            'deposit_sum': { items: new Set(), labels: new Set() },
          }

          for (let k in r) {
            for (let item of r[k]?.data || []) {

              if (!out[item.hour]) out[item.hour] = { hour: item.hour }

              out[item.hour]['amount' + r[k]?.label] = item.amount
              out[item.hour]['deposit_count' + r[k]?.label] = item.deposit_count
              out[item.hour]['account_count' + r[k]?.label] = item.account_count

              y.deposit_sum.items.add('amount' + r[k]?.label)
              y.deposit_count.items.add('deposit_count' + r[k]?.label)
              y.deposit_count.items.add('account_count' + r[k]?.label)

              y.deposit_sum.labels.add('Sum ' + r[k]?.label)
              y.deposit_count.labels.add('Deposit Count ' + r[k]?.label)
              y.deposit_count.labels.add('Account Count ' + r[k]?.label)

            }
          }

          for (let k in this.hourCharts) {
            if (y[this.hourCharts[k].alias]) {
              this.hourCharts[k].data.ykeys = [ ...y[this.hourCharts[k].alias].items ]
              this.hourCharts[k].data.labels = [ ...y[this.hourCharts[k].alias].labels ]
              this.hourCharts[k].data.colors = this.generateColors(y[this.hourCharts[k].alias].items.size)
            }
          }

          return toArray(out)
        }).then(r => {
          this.hourSeries = r
        }).finally(() => {
          this.loading.deposit_by_paymethod = false
        })

      },

    }
  }
</script>

<style scoped>

</style>
